<div *ngIf="isLoading" class="nf-overlay">
  <svg class="nf-spinner" viewBox="0 0 50 50">
    <circle class="nf-spinner__track" cx="25" cy="25" r="20"></circle>
    <circle class="nf-spinner__arc" cx="25" cy="25" r="20"></circle>
  </svg>
</div>

<form *ngIf="!isLoading" class="pb-4" [formGroup]="customerForm" (ngSubmit)="onSubmit()">
  <div class="form-section">
    <p-accordion value="0">
      <p-accordion-panel value="0">
        <p-accordion-header>
          <div class="w-full flex items-center justify-between">
            <span>Primary Information</span>
            <span *ngIf="mode=='edit' || mode=='view'" class="px-3 py-1 text-xs font-semibold mr-2 bg-blue-100 text-blue-700 border border-blue-300 shadow-sm rounded-[0.5rem]">Status: {{ getSOStatusLabel(soStatus) }}</span>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="flex gap-2 items-start">
            <div class="flex-1">
              <app-dynamic-form
                [isLoading]="isLoading"
                [formGroup]="customerForm"
                [data]="primaryFields || []"
                [gridSize]="5"
                [viewMode]="viewMode"
                (fieldChanged)="onChildFieldChanged($event)"
                (searchQuery)="onPrimaryFormSearchQuery($event)">
              </app-dynamic-form>
            </div>

            <div *ngIf="tableData.length != 0" class="w-[12rem]">
              <p-table 
                size="small"
                [tableStyle]="{ 'border': '1px solid #C9D2DC' }"
                [value]="tableData">
                <ng-template #header>
                  <tr>
                    <th colspan="2" class="caption">
                      Summary
                    </th>
                  </tr>
                </ng-template>
                <ng-template #body let-row>
                  <tr class="table-data">
                    <td class="left-data">{{ row.name }}</td>
                    <td class="right-data">₹{{ row.amount | number:'1.0-0' }}</td>
                  </tr>
                </ng-template>
                <ng-template #footer>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>

  <p-tabs value="1">
    <p-tablist>
      <p-tab *ngFor="let tab of dynamicFormTabs" [value]="tab.value.toString()">
        <p class="font-normal text-sm">{{ tab.title }}</p>
      </p-tab>
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel *ngFor="let tab of dynamicFormTabs" [value]="tab.value.toString()">
        <ng-container>
          <div *ngFor="let subTab of tab.sub_tabs" class="mb-6">
            <ng-container *ngIf="subTab.content.length > 0">
              <h5 *ngIf="subTab.show_heading" class="mb-4 font-semibold">
                {{ subTab.title }}
              </h5>

              <app-dynamic-form
                *ngIf="subTab.type !== 'table'; else tableNotSupported"
                [formGroup]="customerForm"
                [viewMode]="viewMode && !subTab.editableInViewMode"
                [data]="subTab.content"
                (fieldChanged)="onChildFieldChanged($event)"
                (searchQuery)="onPrimaryFormSearchQuery($event)">
              </app-dynamic-form>

              <ng-template #tableNotSupported>
                <app-item-dynamic-form
                  [formGroup]="customerForm"
                  [tableKey]="subTab.key"
                  [viewMode]="subTab.auditData ? true : viewMode"
                  [tableArray]="getTableFormArray(subTab.key)"
                  [data]="subTab.content"
                  [suggestionsMap]="getSuggestionsMapForTable(subTab.key)"
                  (searchQuery)="onSearchQuery($event, subTab)"
                  (fieldChanged)="onTableFieldChanged($event, subTab)"
                  [showBulkActionButtons]="true">
                </app-item-dynamic-form>
              </ng-template>
            </ng-container>
          </div>
        </ng-container>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <div class="save-container" *ngIf="!viewMode">
    <p-button type="submit" [label]="mode === 'edit' ? 'Update' : 'Save'" [disabled]="approvalStatus === 'approved' || soStatus === 'closed' || isLoading" />
  </div>
</form>